module.exports = __webpack_public_path__ + "static/media/hero.06cadc52.jpg";